import * as React from 'react';
import { preLoginUrls } from '../../utils';
import Sidebar from './Sidebar';

export default function WithSidebar({ children }) {
  const disabled = preLoginUrls.includes(window.location.pathname);

  return disabled ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <div
      style={{
        display: 'flex',
      }}
    >
      <Sidebar />
      {children}
    </div>
  );
}
